// extracted by mini-css-extract-plugin
export default {"Spin":"Styles_Spin__T64P4","spinner":"Styles_spinner__DrWYc"};